import { render, staticRenderFns } from "./CardProfile.vue?vue&type=template&id=1608017c&scoped=true&"
import script from "./CardProfile.vue?vue&type=script&lang=js&"
export * from "./CardProfile.vue?vue&type=script&lang=js&"
import style0 from "./CardProfile.vue?vue&type=style&index=0&id=1608017c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608017c",
  null
  
)

export default component.exports